import React from 'react';
import LazyLoad from 'react-lazyload';
import PropTypes from 'prop-types';

// When to use this component:
// 1. If you want to serve a webp image with a fallback for browsers that don't support webp
// 2. If you have different mobile & desktop images and want them to change at a 768px (we can expand this if needed in the future)
export default function LazyPicture({
  height,
  width,
  offset = 200,
  style = {},
  className,
  alt = 'missing alt',
  webp = '',
  mobileSrc = '',
  desktopSrc = '',
  fallback = '',
  mobileBreakpoint = '768',
}) {
  return (
    <LazyLoad
      height={height ? `${height}px` : null}
      width={width ? `${width}px` : null}
      placeholder={<span className="lazyload-placeholder" />}
      offset={offset}
      debounce={0}
    >
      <picture className={className}>
        {webp && <source srcSet={webp} type="image/webp" />}
        {mobileSrc && desktopSrc && (
          <>
            <source media={`(min-width: ${mobileBreakpoint}px)`} srcSet={desktopSrc} />
            <source srcSet={mobileSrc} />
          </>
        )}
        <img src={fallback} alt={alt} height={height} width={width} style={style} />
      </picture>
    </LazyLoad>
  );
}

LazyPicture.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  offset: PropTypes.number,
  style: PropTypes.shape({}),
  className: PropTypes.string,
  alt: PropTypes.string,
  webp: PropTypes.string,
  mobileSrc: PropTypes.string,
  desktopSrc: PropTypes.string,
  fallback: PropTypes.string,
  mobileBreakpoint: PropTypes.string,
};
